// src/components/BookingInfoCard.js

import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { format as formatDateFn } from 'date-fns';

const BookingInfoCardStyled = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
}));

const BookingInfoItemStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
}));

const BookingInfoCard = ({ startDate, endDate, bookingNumber, totalPrice }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return formatDateFn(date, "EEE, MMM d, yyyy");
    };

    return (
        <BookingInfoCardStyled>
            <CardContent>
                <BookingInfoItemStyled>
                    <CalendarTodayIcon />
                    <Box>
                        <Typography variant="subtitle2">Rental period</Typography>
                        <Typography variant="body2">
                            {formatDate(startDate)} - {formatDate(endDate)}
                        </Typography>
                    </Box>
                </BookingInfoItemStyled>
                <BookingInfoItemStyled>
                    <ConfirmationNumberIcon />
                    <Box>
                        <Typography variant="subtitle2">Booking number</Typography>
                        <Typography variant="body2">{bookingNumber}</Typography>
                    </Box>
                </BookingInfoItemStyled>
                <BookingInfoItemStyled>
                    <AttachMoneyIcon />
                    <Box>
                        <Typography variant="subtitle2">Total price</Typography>
                        <Typography variant="body2">
                            ${totalPrice.toFixed(2)}
                            <Typography variant="caption" color="textSecondary" component="span" ml={1}>
                                (incl. booking fee)
                            </Typography>
                        </Typography>
                    </Box>
                </BookingInfoItemStyled>
            </CardContent>
        </BookingInfoCardStyled>
    );
};

export default BookingInfoCard;
